import {Injectable} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgAppControllerConfig} from '../misc/classes/ExgAppControllerConfig';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IMessageRepositoryData} from '../misc/interfaces/IMessageRepositoryData';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ExgModalService} from 'exc-controls-v2';


@Injectable({
  providedIn: 'root'
})
export class MessageDataService extends ExcTranslation {

  Message = {
    UpdateDone: (ID: string, done: boolean): Observable<any> => {
      return this.excRest.put(this.excRest.computeUrl('MessageU_Done', {msgID: ID}), {done}).pipe(map(response => {
        if (response && response.success) {
          this.modal.showToast((done) ? 'Nachricht als erledigt markiert' : 'Nachricht als nicht erledigt markiert', 'md-toast', 'fal fa-check');
        }
      }));
    },
    UpdateCategory: (ID: string, category: number): Observable<any> => {
      return this.excRest.put(this.excRest.computeUrl('MessageU_SetCategory', {msgID: ID}), {category}).pipe(map(response => {
        if (response && response.success) {
          this.modal.showToast('Nachrichtenkategorie gespeichert', 'md-toast', 'fal fa-flag');
        }
      }));
    },
    SetRead: (ID: string): Observable<any> => {
      return this.excRest.put(this.excRest.computeUrl('MessageU_RecipientSetRead', {msgID: ID}), {}).pipe(map(response => {
        if (response && response.success) {
          this.modal.showToast('Nachricht als gelesen markiert', 'md-toast', 'fal fa-envelope-open');
        }
      }));
    },
    Repository: {
      Get: (ID?: string, config?: ExgAppControllerConfig): Observable<IMessageRepositoryData> => {
        const empty: IMessageRepositoryData = {Placeholder: {}, Textbaustein: []};
        const mapFn = this.excRest
          .get(this.excRest.computeUrl('MessageR_Repository', {oid: ID})).pipe(
            map<any, IMessageRepositoryData>((response) => {
                if (response.success && response.data) {
                  return {Placeholder: response.data.Placeholder, Textbaustein: response.data.Textbaustein};
                } else {
                  return empty;
                }
              },
              catchError((err) => {
                return of(empty);
              })));
        return mapFn;
      }
    }
  };

  constructor(private excRest: ExcRestService, private modal: ExgModalService) {
    super();
  }
}

